module.exports = __webpack_public_path__ + "img/pc_p3_y6.d43b0c51.png";